import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'app/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-sistema-menu-aside',
  templateUrl: './menu-aside.component.html',
  styleUrls: ['./menu-aside.component.css']
})
export class MenuAsideComponent implements OnInit {

  usuario = JSON.parse(localStorage.getItem('usuario'));
  configuracion = JSON.parse(localStorage.getItem('configuracion'));
  menu: any[] = [];
  toggle: boolean = false;
  fondo;
  openmenu = [];
  API_PATH = environment.API_PATH;

  menuactual: string;
  tamano = document.body.clientHeight;
  constructor(private router: Router, private authService: AuthService, ) { }


  ngOnInit() {

    let menu = JSON.parse(localStorage.getItem("menu"));
    this.fondo = './assets/fondo.png';
    if (this.configuracion.sucursal)
    this.fondo = this.configuracion.sucursal.fondo ? this.API_PATH + '/adjunto/configuracion/' + this.configuracion.sucursal.fondo : './assets/fondo.png';

    let url = location.href.split("/");
    this.menuactual = " " + url[4];
    this.menuactual = this.menuactual.toLowerCase()
      .replace(/[-_]+/g, ' ')
      .replace(/[^\w\s]/g, '')
      .replace(/ (.)/g, function ($1) { return $1.toUpperCase(); })
      .replace(/ /g, '');

    for (let item of menu) {
      if (item.titulo == this.menuactual || item.path.indexOf(url[4]) > -1) {
        if (this.menu.indexOf(item) < 0)
          this.menu.push(item);
      }
    }
  }
  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
